import { gql, useMutation } from '@apollo/client';

import type {
  UpdateDependentPhoneNumberMutation,
  UpdateDependentPhoneNumberMutationVariables,
} from './__generated__/useUpdateDependentPhoneNumber.gql';

const UPDATE_DEPENDENT_PHONE_NUMBER = gql`
  mutation UpdateDependentPhoneNumber($input: UpdateDependentPhoneNumberInput!) {
    updateDependentPhoneNumber(input: $input) {
      id
      phoneNumber
      phoneNumberVerifiedAt
      phoneVerificationStartedAt
    }
  }
`;

/**
 * Change the number a loved one is reached on, wherever that number lives.
 *
 * Distinct from `useUpdateDependentContact`, which writes the `dependants`
 * profile through `updateDependant` and is refused for anyone who has enrolled.
 * This one lets the server pick the row from linkage, so the caller does not
 * have to know which applies.
 *
 * Both stamps are selected because the write clears both: a new number is
 * unproven by definition, and the same write retires any handshake still out on
 * the old one. Apollo merges the response into the existing `Dependant:<id>`
 * record, so an unselected stamp would keep its stale non-null value and strand
 * the card reporting a verification that no longer exists.
 *
 * @returns The standard `useMutation` tuple — `[mutate, MutationResult]`.
 */
export const useUpdateDependentPhoneNumber = () => {
  return useMutation<UpdateDependentPhoneNumberMutation, UpdateDependentPhoneNumberMutationVariables>(
    UPDATE_DEPENDENT_PHONE_NUMBER
  );
};
